export const serviceValidator = (fields) => {
  const errors = {};

  if (!fields.title || fields.title.trim() === "") {
    errors.title = "El título no puede estar vacío";
  }

  if (!fields.id || fields.id.trim() === "") {
    errors.id = "El ID no puede estar vacío";
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/views/Configurator/utils/serviceValidator.js